import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IntroPage from "../pages/IntroPage";
import AuthPage from "../pages/AuthPage";
import LecturePage from "../pages/LecturePage";
import LectureEndPage from "../pages/LectureEndPage";
import NotFoundPage from "../pages/NotFoundPage";

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<IntroPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/lecture" element={<LecturePage />} />
                <Route path="/lecture/end" element={<LectureEndPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
